import { useState } from "react";
import "./PinLoginPage.css";
import { useLocation, useNavigate } from "react-router-dom";
import { authService } from "../../../services";
import { authUserSignal } from "../../../signals/authSignal";
import { useLanguage } from "../../../contexts/LanguageContext";
import { createLogger } from "../../../utils/logger";
import PinKeypad from "./PinKeypad";

const logger = createLogger("PinLoginPage");

const PinLoginPage = () => {
  const { t } = useLanguage();

  const appVersion = `${import.meta.env.VITE_APP_NAME}@${import.meta.env.VITE_APP_VERSION}`

  const [pinString, setPinString] = useState<string>("");
  const [showDigits, setShowDigits] = useState(false); // by default hide digits
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const clearPin = () => {
    if (pinString.length > 0) {
      setPinString(pinString.slice(0, -1));
    }
  };

  const handleLogin = async () => {

    if(!processing){
      setProcessing(true);
      const result = await authService.login(pinString);
      logger.debug('handleLogin: success=', result);
      if (result) {
        const user = await authService.readUser();

        //signal
        authUserSignal.value = user;

        if (user?.mustChangePassword) {
          logger.debug('mustChangePassword=true, redirecting to /change-access-code');
          navigate('/change-access-code', { state: { from }, replace: true });
        } else {
          logger.debug('redirect to=', from);
          navigate(from, { replace: true });
        }
      }
      else {
        setShowError(true);
        setTimeout(()=>{
          setShowError(false);
        },3*1000);

      }
      setProcessing(false);
    }
  };

  return (
    <>
      <div className="container-fluid vh-100 d-flex justify-content-center align-items-center pin-login-container">
        <div className="pin-login-panel text-center p-4 rounded rounded-3 animate__animated animate__zoomIn">
          <h2 className="mb-2"></h2>

          <PinKeypad
            value={pinString}
            onDigit={(digit) => setPinString(pinString + digit)}
            onBackspace={clearPin}
            onSubmit={handleLogin}
            showDigits={showDigits}
            onToggleShowDigits={() => setShowDigits(!showDigits)}
            disabled={processing}
          />

           <div className="row row-pin mb-2 text-center">
             <button
               disabled={processing}
               className={
                 showError ? "btn-theme btn-pin-login mx-2 mt-3 animate__animated animate__headShake rounded" : "btn-theme btn-pin-login mx-2 mt-3 rounded"
               }
               onClick={handleLogin}
             >
               {showError ? t("login.invalid") : t("login.logIn")}
             </button>
           </div>
          <div className="font-7">{appVersion}</div>
        </div>
      </div>
    </>
  );
};

export default PinLoginPage;
